import { useGalleryStore } from '../stores/galleryStore';

// ponytail: GalleryContext thin facade mapping to galleryStore.
export const useGallery = () => useGalleryStore();

export const GalleryProvider = ({ children }) => <>{children}</>;

export default useGalleryStore;
